import { render, staticRenderFns } from "./AdminEtiketten.vue?vue&type=template&id=3577e2e0&"
import script from "./AdminEtiketten.vue?vue&type=script&lang=js&"
export * from "./AdminEtiketten.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports